const cadastar_o_tipo_da_solicitacao = [
  {
    path: "/cadastrar-o-tipo-da-solicitacao",
    redirect: "",
    meta: {
      breadCrumb:
        "Gestão - Cadastrar as Solicitações de Serviços de uma Unidade para outra",
    },
    children: [
      {
        path: "/cadastrar-o-tipo-da-solicitacao",
        name: "cadastrar_o_tipo_da_solicitacao",
        component: () =>
          import(
            "@/views/CadastroTipoDaSolicitacao/CadastroTipoDaSolicitacaoHome.vue"
          ),
      },
      {
        path: "/cadastrar-o-tipo-da-solicitacao/novo",
        name: "cadastrar_o_tipo_da_solicitacao_novo",
        component: () =>
          import(
            "@/views/CadastroTipoDaSolicitacao/CadastroTipoDaSolicitacaoCadastro.vue"
          ),
      },
      {
        path: "/cadastrar-o-tipo-da-solicitacao/:id",
        name: "cadastrar_o_tipo_da_solicitacao_editar",
        component: () =>
          import(
            "@/views/CadastroTipoDaSolicitacao/CadastroTipoDaSolicitacaoEditar.vue"
          ),
      },
    ],
  },
];

export { cadastar_o_tipo_da_solicitacao };
